import { TelaBanner } from '../services/bannerService';

/**
 * ⚠️ CACHE EXCLUSIVO PARA A PÁGINA SCREENS ⚠️
 * 
 * Este cache é de USO EXCLUSIVO para a página ScreensPageIntegrated.
 * 
 * NÃO USE ESTE CACHE em outras páginas que usam useBanners ou outros métodos
 * de buscar banners. Cada página deve ter seu próprio gerenciamento de estado.
 * 
 * Propósito:
 * - Manter dados das telas em memória mesmo quando a página Screens desmonta/remonta
 * - Evitar recarregamentos desnecessários ao navegar entre menus do programa
 * - Carregar apenas uma vez quando a pessoa entra na página Screens
 * - Recarregar apenas se: reiniciar a página OU clicar no botão sincronizar
 * 
 * IMPORTANTE: Este cache NÃO deve ser usado em:
 * - PromotionsPage
 * - DisplayPage
 * - ScreenSelectorModal
 * - Qualquer outra página que use useBanners()
 */
class BannerCache {
    private telas: TelaBanner[] = [];
    private loading: boolean = false;
    private error: string | null = null;
    private lastLoadTime: number = 0;
    private isLoading: boolean = false;

    private company: string | null = null;

    /**
     * Verifica se os dados estão em cache e ainda válidos
     * @param currentCompany - Opcional: empresa atual para validar se o cache pertence a ela
     */
    hasData(currentCompany?: string): boolean {
        // Se foi fornecida uma empresa e for diferente da que está no cache, os dados são inválidos
        if (currentCompany && this.company !== currentCompany) {
            return false;
        }
        return this.telas.length > 0 && this.lastLoadTime > 0;
    }

    /**
     * Retorna os dados do cache
     */
    getTelas(): TelaBanner[] {
        return this.telas;
    }

    /**
     * Retorna o estado de loading
     */
    isLoadingState(): boolean {
        return this.isLoading;
    }

    /**
     * Retorna o erro, se houver
     */
    getError(): string | null {
        return this.error;
    }

    /**
     * Define os dados no cache
     * @param telas - Lista de telas
     * @param company - Opcional: empresa a qual esses dados pertencem
     */
    setTelas(telas: TelaBanner[], company?: string): void {
        this.telas = telas;
        this.lastLoadTime = Date.now();
        this.error = null;
        if (company) {
            this.company = company;
        }
    }

    /**
     * Define o estado de loading
     */
    setLoading(loading: boolean): void {
        this.isLoading = loading;
    }

    /**
     * Define o erro
     */
    setError(error: string | null): void {
        this.error = error;
    }

    /**
     * Limpa o cache (útil para forçar recarregamento)
     */
    clear(): void {
        this.telas = [];
        this.lastLoadTime = 0;
        this.error = null;
        this.isLoading = false;
        this.company = null;
    }

    /**
     * Retorna o timestamp da última carga
     */
    getLastLoadTime(): number {
        return this.lastLoadTime;
    }
}

// Instância singleton do cache
export const bannerCache = new BannerCache();

